
var id = "BasketSize";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"BasketSize\">\n<style type=\"text/css\">\n\t#BasketSize .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M64.1,116.6C35,116.6,11.5,93.1,11.5,64S35,11.4,64.1,11.4s52.6,23.6,52.6,52.6S93.2,116.6,64.1,116.6z\n\t M64.1,126.2c34.4,0,62.2-27.9,62.2-62.2S98.4,1.8,64.1,1.8S1.9,29.6,1.9,64S29.7,126.2,64.1,126.2z\" />\n<path class=\"st0\" d=\"M64.1,81.2c-9.9,0-17.9-8-17.9-17.9s8-17.9,17.9-17.9s17.9,8,17.9,17.9S74,81.2,64.1,81.2z M64.1,89.9\n\tc14.6,0,26.5-11.9,26.5-26.5S78.7,36.9,64.1,36.9S37.6,48.8,37.6,63.4S49.5,89.9,64.1,89.9z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
